import { composite } from "seemly";

// https://github.com/TuSimple/naive-ui/blob/main/themes/tusimple/src/theme-overrides-light.ts#L6
export const createHoverColor = (
  color: string,
  overlayAlpha = 0.15
): string => {
  return composite(color, [255, 255, 255, overlayAlpha]);
};

// https://github.com/TuSimple/naive-ui/blob/main/themes/tusimple/src/theme-overrides-light.ts#L10
export const createPressedColor = (
  color: string,
  overlayAlpha = 0.15
): string => {
  return composite(color, [0, 0, 0, overlayAlpha]);
};
